// extracted by mini-css-extract-plugin
module.exports = {"paragraphs":"paragraphs-module--paragraphs--2cOq_","heading":"paragraphs-module--heading--3T7Y4","paragraph":"paragraphs-module--paragraph--2bMnh"};